/* tslint:disable */
/* eslint-disable */
/**
 * Cerebral Machines API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DictionaryEntryCreate } from '../models';
// @ts-ignore
import type { DictionaryEntryUpdate } from '../models';
// @ts-ignore
import type { ValidationErrorModel } from '../models';
/**
 * DictionaryEntryApi - axios parameter creator
 */
export const DictionaryEntryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new dictionary entry
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryCreatePost: async (dictionaryEntryCreate: DictionaryEntryCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryEntryCreate' is not null or undefined
            assertParamExists('dictionaryEntryCreatePost', 'dictionaryEntryCreate', dictionaryEntryCreate)
            const localVarPath = `/api/dictionary-entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryEntryCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a dictionary entry by ID
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryDeleteEntryIdDelete: async (entryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('dictionaryEntryDeleteEntryIdDelete', 'entryId', entryId)
            const localVarPath = `/api/dictionary-entries/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a dictionary entry by ID
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryGetEntryIdGet: async (entryId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('dictionaryEntryGetEntryIdGet', 'entryId', entryId)
            const localVarPath = `/api/dictionary-entries/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all dictionary entries
         * @param {string | null} [search] 
         * @param {string | null} [scopeType] 
         * @param {string | null} [graphId] 
         * @param {string | null} [canonicalTermId] 
         * @param {boolean | null} [isEnabled] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryListGet: async (search?: string | null, scopeType?: string | null, graphId?: string | null, canonicalTermId?: string | null, isEnabled?: boolean | null, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dictionary-entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (scopeType !== undefined) {
                localVarQueryParameter['scope_type'] = scopeType;
            }

            if (graphId !== undefined) {
                localVarQueryParameter['graph_id'] = graphId;
            }

            if (canonicalTermId !== undefined) {
                localVarQueryParameter['canonical_term_id'] = canonicalTermId;
            }

            if (isEnabled !== undefined) {
                localVarQueryParameter['is_enabled'] = isEnabled;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a dictionary entry by ID
         * @param {string} entryId 
         * @param {DictionaryEntryUpdate} dictionaryEntryUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryUpdateEntryIdPut: async (entryId: string, dictionaryEntryUpdate: DictionaryEntryUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entryId' is not null or undefined
            assertParamExists('dictionaryEntryUpdateEntryIdPut', 'entryId', entryId)
            // verify required parameter 'dictionaryEntryUpdate' is not null or undefined
            assertParamExists('dictionaryEntryUpdateEntryIdPut', 'dictionaryEntryUpdate', dictionaryEntryUpdate)
            const localVarPath = `/api/dictionary-entries/{entry_id}`
                .replace(`{${"entry_id"}}`, encodeURIComponent(String(entryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryEntryUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionaryEntryApi - functional programming interface
 */
export const DictionaryEntryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionaryEntryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new dictionary entry
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryEntryCreatePost(dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryEntryCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryEntryCreatePost(dictionaryEntryCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryEntryApi.dictionaryEntryCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a dictionary entry by ID
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryEntryDeleteEntryIdDelete(entryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryEntryDeleteEntryIdDelete(entryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryEntryApi.dictionaryEntryDeleteEntryIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a dictionary entry by ID
         * @param {string} entryId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryEntryGetEntryIdGet(entryId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryEntryGetEntryIdGet(entryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryEntryApi.dictionaryEntryGetEntryIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all dictionary entries
         * @param {string | null} [search] 
         * @param {string | null} [scopeType] 
         * @param {string | null} [graphId] 
         * @param {string | null} [canonicalTermId] 
         * @param {boolean | null} [isEnabled] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryEntryListGet(search?: string | null, scopeType?: string | null, graphId?: string | null, canonicalTermId?: string | null, isEnabled?: boolean | null, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryEntryListGet(search, scopeType, graphId, canonicalTermId, isEnabled, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryEntryApi.dictionaryEntryListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a dictionary entry by ID
         * @param {string} entryId 
         * @param {DictionaryEntryUpdate} dictionaryEntryUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryEntryUpdateEntryIdPut(entryId: string, dictionaryEntryUpdate: DictionaryEntryUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryEntryUpdateEntryIdPut(entryId, dictionaryEntryUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryEntryApi.dictionaryEntryUpdateEntryIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionaryEntryApi - factory interface
 */
export const DictionaryEntryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionaryEntryApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new dictionary entry
         * @param {DictionaryEntryApiDictionaryEntryCreatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryCreatePost(requestParameters: DictionaryEntryApiDictionaryEntryCreatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryEntryCreate> {
            return localVarFp.dictionaryEntryCreatePost(requestParameters.dictionaryEntryCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a dictionary entry by ID
         * @param {DictionaryEntryApiDictionaryEntryDeleteEntryIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryDeleteEntryIdDelete(requestParameters: DictionaryEntryApiDictionaryEntryDeleteEntryIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryEntryDeleteEntryIdDelete(requestParameters.entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a dictionary entry by ID
         * @param {DictionaryEntryApiDictionaryEntryGetEntryIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryGetEntryIdGet(requestParameters: DictionaryEntryApiDictionaryEntryGetEntryIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryEntryGetEntryIdGet(requestParameters.entryId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all dictionary entries
         * @param {DictionaryEntryApiDictionaryEntryListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryListGet(requestParameters: DictionaryEntryApiDictionaryEntryListGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryEntryListGet(requestParameters.search, requestParameters.scopeType, requestParameters.graphId, requestParameters.canonicalTermId, requestParameters.isEnabled, requestParameters.limit, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a dictionary entry by ID
         * @param {DictionaryEntryApiDictionaryEntryUpdateEntryIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryEntryUpdateEntryIdPut(requestParameters: DictionaryEntryApiDictionaryEntryUpdateEntryIdPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryEntryUpdateEntryIdPut(requestParameters.entryId, requestParameters.dictionaryEntryUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dictionaryEntryCreatePost operation in DictionaryEntryApi.
 */
export interface DictionaryEntryApiDictionaryEntryCreatePostRequest {
    readonly dictionaryEntryCreate: DictionaryEntryCreate
}

/**
 * Request parameters for dictionaryEntryDeleteEntryIdDelete operation in DictionaryEntryApi.
 */
export interface DictionaryEntryApiDictionaryEntryDeleteEntryIdDeleteRequest {
    readonly entryId: string
}

/**
 * Request parameters for dictionaryEntryGetEntryIdGet operation in DictionaryEntryApi.
 */
export interface DictionaryEntryApiDictionaryEntryGetEntryIdGetRequest {
    readonly entryId: string
}

/**
 * Request parameters for dictionaryEntryListGet operation in DictionaryEntryApi.
 */
export interface DictionaryEntryApiDictionaryEntryListGetRequest {
    readonly search?: string | null

    readonly scopeType?: string | null

    readonly graphId?: string | null

    readonly canonicalTermId?: string | null

    readonly isEnabled?: boolean | null

    readonly limit?: number | null

    readonly offset?: number | null
}

/**
 * Request parameters for dictionaryEntryUpdateEntryIdPut operation in DictionaryEntryApi.
 */
export interface DictionaryEntryApiDictionaryEntryUpdateEntryIdPutRequest {
    readonly entryId: string

    readonly dictionaryEntryUpdate: DictionaryEntryUpdate
}

/**
 * DictionaryEntryApi - object-oriented interface
 */
export class DictionaryEntryApi extends BaseAPI {
    /**
     * 
     * @summary Create a new dictionary entry
     * @param {DictionaryEntryApiDictionaryEntryCreatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryEntryCreatePost(requestParameters: DictionaryEntryApiDictionaryEntryCreatePostRequest, options?: RawAxiosRequestConfig) {
        return DictionaryEntryApiFp(this.configuration).dictionaryEntryCreatePost(requestParameters.dictionaryEntryCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a dictionary entry by ID
     * @param {DictionaryEntryApiDictionaryEntryDeleteEntryIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryEntryDeleteEntryIdDelete(requestParameters: DictionaryEntryApiDictionaryEntryDeleteEntryIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DictionaryEntryApiFp(this.configuration).dictionaryEntryDeleteEntryIdDelete(requestParameters.entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a dictionary entry by ID
     * @param {DictionaryEntryApiDictionaryEntryGetEntryIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryEntryGetEntryIdGet(requestParameters: DictionaryEntryApiDictionaryEntryGetEntryIdGetRequest, options?: RawAxiosRequestConfig) {
        return DictionaryEntryApiFp(this.configuration).dictionaryEntryGetEntryIdGet(requestParameters.entryId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all dictionary entries
     * @param {DictionaryEntryApiDictionaryEntryListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryEntryListGet(requestParameters: DictionaryEntryApiDictionaryEntryListGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DictionaryEntryApiFp(this.configuration).dictionaryEntryListGet(requestParameters.search, requestParameters.scopeType, requestParameters.graphId, requestParameters.canonicalTermId, requestParameters.isEnabled, requestParameters.limit, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a dictionary entry by ID
     * @param {DictionaryEntryApiDictionaryEntryUpdateEntryIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryEntryUpdateEntryIdPut(requestParameters: DictionaryEntryApiDictionaryEntryUpdateEntryIdPutRequest, options?: RawAxiosRequestConfig) {
        return DictionaryEntryApiFp(this.configuration).dictionaryEntryUpdateEntryIdPut(requestParameters.entryId, requestParameters.dictionaryEntryUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

